import { useAuth0 } from "@auth0/auth0-react"
import React, { useContext, useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { Table } from "semantic-ui-react"
import { hasFeatureInPackage, isSuperAdminOrAdmin, isSuperAdminOrResellerAdmin, isSuperAdminOrResellerAdminOrAdmin } from "../../../../Utils/util"
import Error404 from "../../../OtherPages/ErrorPage/Error404"
import "../../../Pages.scss"

import BifrostTable from "../../../../Components/BifrostElementComponent/BifrostTable/BifrostTable"
import { useGetGroups } from "../../../../Hooks/FetchHooks/GetDataService/useGetGroups"
import userInfoContext from "../../../../store/userInfoContext"
import MainPanelFooter from "../../MainPanelFooter/MainPanelFooter"
import MainPanelHeader from "../../MainPanelHeader/MainPanelHeader"
import CreateGroupModal from "./GroupModal/CreateGroupModal/CreateGroupModal"

const GroupsPage = () => {
	const userInfo = useContext(userInfoContext)
	const nav = useNavigate()

	const { user, isAuthenticated } = useAuth0()
	const { data, setData, isLoading, getGroups } = useGetGroups()

	const columns = React.useMemo(() => {
		const superAdminColumns = isSuperAdminOrResellerAdmin(user)
			? [
					{
						name: "Organization",
						key: "org_name",
						type: "string"
					}
			  ]
			: []

		return superAdminColumns.concat([
			{
				name: "Name",
				key: "name",
				type: "string"
			},
			{
				name: "Users",
				key: "no_users",
				type: "number"
			},
			{
				name: "Devices",
				key: "no_devices",
				type: "number"
			},
			{
				name: "Last Session (UTC)",
				key: "last_session",
				type: "number"
			},
			{
				name: "Delete",
				key: "delete",
				isUnSortable: true
			}
		])
	}, [user])
	const filterGroup = (group, filter) => {
		if (!filter || filter === "") return true
		else return group.name.toLowerCase().includes(filter.toLowerCase()) || group.org_name.toLowerCase().includes(filter.toLowerCase())
	}
	const GroupRow = ({ item }) => (
		<Table.Row key={item.id} style={{ cursor: "pointer" }} onClick={() => nav(`/groups/${item.id}`, { state: { name: item.name } })}>
			{isSuperAdminOrResellerAdmin(user) ? <Table.Cell>{item.org_name}</Table.Cell> : null}
			<Table.Cell>{item.name}</Table.Cell>
			<Table.Cell>{item.no_users}</Table.Cell>
			<Table.Cell>{item.no_devices}</Table.Cell>
			<Table.Cell>{item.last_session}</Table.Cell>
			{isSuperAdminOrAdmin(user) ? <Table.Cell onClick={(e) => e.stopPropagation()}>{item.delete}</Table.Cell> : null}
		</Table.Row>
	)

	useEffect(() => {
		if (isAuthenticated && isSuperAdminOrResellerAdminOrAdmin(user) && userInfo && userInfo.terms_accepted) {
			getGroups()
		}
		return () => setData([])
	}, [isAuthenticated])

	return !isSuperAdminOrResellerAdminOrAdmin(user) || process.env.REACT_APP_SAML_ENABLED === "true" || !hasFeatureInPackage(userInfo, "groups") ? (
		<Error404 />
	) : (
		<section className={"bifrost-table-panel devices-table"}>
			<MainPanelHeader title="Groups" fetchData={getGroups}>
				<div className="create-group-modal">
					<CreateGroupModal refreshGroups={getGroups} />
				</div>
			</MainPanelHeader>
			<BifrostTable
				loading={isLoading}
				pageName="Groups"
				data={data}
				columns={columns}
				Row={GroupRow}
				filterFunc={filterGroup}
				defaultSort={{ order: "ascending", column: isSuperAdminOrResellerAdmin(user) ? "org_name" : "name" }}
				isSelectable={!isLoading}
				fetchData={getGroups}
			/>
			<MainPanelFooter />
		</section>
	)
}

export default GroupsPage
